export let Level;
(function (Level) {
  Level[Level["ALL"] = -Infinity] = "ALL";
  Level[Level["DEBUG"] = 10] = "DEBUG";
  Level[Level["INFO"] = 11] = "INFO";
  Level[Level["WARNING"] = 12] = "WARNING";
  Level[Level["ERROR"] = 13] = "ERROR";
  Level[Level["OFF"] = +Infinity] = "OFF";
})(Level || (Level = {}));